export const config = {
    appId: "1b255661-6654-4b2f-9658-0dc1280206f9",
    redirectUri: "https://salesbudget.gsk.com/loginv2",//UAT
    // redirectUri: "http://localhost:3000/loginv2",
    scopes: [
        "user.read",
        // "mailboxsettings.read",
        // "calendars.readwrite"
    ],
    authority: "https://login.microsoftonline.com/gsk.com",
};
